import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCB6WKtLu5pC6T3Kk3jgL-cFZXxoTKghwg",
  authDomain: "arelchen-law.firebaseapp.com",
  projectId: "arelchen-law",
  storageBucket: "arelchen-law.firebasestorage.app",
  messagingSenderId: "536306299050",
  appId: "1:536306299050:web:b6afe6fd96d61c3154e0d3",
  measurementId: "G-M0FLXGB1Y8"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;